<script lang="ts" setup>
import { Head, usePage } from "@inertiajs/vue3";
import HeadingComponent from "../../Components/HeadingComponent.vue";
import { Duration } from "luxon";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import { Event, Track } from "@/types";
import { provide } from "vue";

interface Props {
    event?: Event;
    track?: Track;
}

onMounted(() => {});

onUnmounted(() => {});
import { computed, inject, nextTick, onMounted, onUnmounted, reactive, ref } from "vue";
import PlayerMap from "@/Pages/Player/PlayerMap.vue";

const props = withDefaults(defineProps<Props>(), {});
const allTracksPolygonCoords = [];

if (usePage().props.event_all_tracks_polygons) {
    // Polygon un MultiPolygon tiek pārvērsti par MultiPolygon
    for (let i = 0, k = Object.keys(usePage().props.event_all_tracks_polygons), l = k.length; i < l; i++) {
        const poly = usePage().props.event_all_tracks_polygons[k[i]];
        // console.log("poly", poly);
        allTracksPolygonCoords[i] = [];
        for (let i2 = 0, l2 = poly.coordinates.length; i2 < l2; i2++) {
            // console.log("poly.coordinates[i2]", poly.coordinates[i2]);
            if (poly.type === "MultiPolygon") {
                allTracksPolygonCoords[i].push(...poly.coordinates[i2][0]);
            } else {
                allTracksPolygonCoords[i].push(...poly.coordinates[i2]);
            }
        }
    }
}

if (usePage().props.track_polygons) {
    // Polygon un MultiPolygon tiek pārvērsti par MultiPolygon
    for (let i = 0, k = Object.keys(usePage().props.track_polygons), l = k.length; i < l; i++) {
        const poly = usePage().props.track_polygons[k[i]];
        // console.log("poly", poly);
        allTracksPolygonCoords[i] = [];
        for (let i2 = 0, l2 = poly.coordinates.length; i2 < l2; i2++) {
            // console.log("poly.coordinates[i2]", poly.coordinates[i2]);
            if (poly.type === "MultiPolygon") {
                allTracksPolygonCoords[i].push(...poly.coordinates[i2][0]);
            } else {
                allTracksPolygonCoords[i].push(...poly.coordinates[i2]);
            }
        }
    }
}
let hq = null;
if (usePage().props.event && usePage().props.event.hq_location) {
    hq = usePage().props.event.hq_location.coordinates;
}
if (
    hq === null &&
    usePage().props.track &&
    usePage().props.track.latestVersion &&
    usePage().props.track.latestVersion.polygon &&
    usePage().props.track.latestVersion.polygon.coordinates &&
    usePage().props.track.latestVersion.polygon.coordinates[0] &&
    usePage().props.track.latestVersion.polygon.coordinates[0][0]
) {
    hq = usePage().props.track.latestVersion.polygon.coordinates[0][0];
}
const myProps = reactive({
    penaltiesSidebarCcs: null,
    timezone: props.event ? props.event.timezone : props.track.timezone,
    allTracksPolygonCoords: allTracksPolygonCoords,
    hq_location_coordinates: hq,

    ridesPositionFeature: null,
    isSliderAnimating: true,
    isLoaded: true,
    isFollowCcsIdFirstClick: null,
    isFollowCcsId: null,
    animationSpeed: 30,
    // inital replay sākas no DSS-60
    dss_ts: new Date(props.event ? props.event.start_at : usePage().props.dss_at).getTime() / 1000,
    timeSliderValue:
        new Date(props.event ? props.event.start_at : usePage().props.dss_at).getTime() / 1000 - 60, // 1697198632
    timeSliderMin: 99697198687, // random big number
    timeSliderMax: 0,
    isPenaltiesSidebarOpen: true,
    isMapInited: false,
});

import { ListBulletIcon, ChevronLeftIcon } from "@heroicons/vue/24/outline";
import CcsPenaltiesTooltipContent from "@/Pages/EventPublic/Components/CcsPenaltiesTooltipContent.vue";

import SpinnerIcon from "@/Components/assets/SpinnerIcon.vue";
import CompetitorClassSectionPenaltiesFormModal from "@/Pages/EventPublic/Components/CompetitorClassSectionPenaltiesFormModal.vue";
import Toast from "@/Components/Toast.vue";
import PlayerSlider from "@/Pages/Player/PlayerSlider.vue";
import PlayerPenaltiesControl from "@/Pages/Player/PlayerPenaltiesControl.vue";
import DialogModal from "@/Components/DialogModal.vue";
import Button from "@/Components/Button.vue";
import axios from "axios";
import PlayerSectionsMenuEvent from "@/Pages/Player/PlayerSectionsMenuEvent.vue";
import PlayerSectionsMenuTrack from "@/Pages/Player/PlayerSectionsMenuTrack.vue";
import PlayerLogoBlock from "@/Components/PlayerLogoBlock.vue";

const modalDeleteTracepoints = reactive({
    show: false,
    feature: null,
});

function confirmTracepointDeletion(which) {
    if (confirm("Really delete? This operation is irreversible!")) {
        axios
            .post(
                route("delete-tracepoint", {
                    tracepoint: modalDeleteTracepoints.feature.properties.id,
                    which: which, // clicked | after | before
                }),
            )
            .then((response) => {
                // to force reload
                // window.top.location.hash = window.top.location.hash + "|";
                window.location.reload();
                // if (inIframe()){
                //   window.top.location.reload();
                // }
                // else{
                //   window.location.reload();
                // }
                // eventBus.$emit("showToast", {
                //     message:
                //         "Competitor section data updated. Note: Refresh page (F5) to see updated competitor position in the section.",
                // });
            });
    }
}

const staticDesktopSidebarOpen = ref(true);

// nevar taisīt reactive, tad tur bremzē uz updateMap() access speed
const competitorClassSectionsPlayerData = {};
const trackVersionsData = {};
const mapComponent = ref(null);

function updateCcsFromPenaltiesModal(ccsFromServer) {
    // console.log("ccsFromServer", ccsFromServer);
    if (props.event) {
        // sameklējam ccs
        for (let i3 = 0, l3 = props.event.classes.length; i3 < l3; i3++) {
            for (let i2 = 0, l2 = props.event.classes[i3].classSections.length; i2 < l2; i2++) {
                const sect = props.event.classes[i3].classSections[i2];

                for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                    if (sect.competitorClassSections[i].id === ccsFromServer.id) {
                        // console.log("sect.competitorClassSections[i]", sect.competitorClassSections[i]);
                        for (let i4 = 0, k4 = Object.keys(ccsFromServer), l4 = k4.length; i4 < l4; i4++) {
                            sect.competitorClassSections[i][k4[i4]] = ccsFromServer[k4[i4]];
                        }
                    }
                }
            }
        }
    } else {
        console.log("TRACK updateCcsFromPenaltiesModal");
    }
}

const dialogModal = reactive({
    show: false,
    msg: "",
    msg2: "",
});

function loadCompetitorClassSectionData(competitorClassSection, competitorIndex, type, section) {
    competitorClassSection.isLoadingCcsData = true;
    axios
        .get(
            route("player.load_competitor_class_section_data", {
                competitor_class_section_id: competitorClassSection.id,
                t: Math.round(new Date().getTime() / 1000),
            }),
        )
        .then((response) => {
            // console.log("response.data", response.data);

            if (response.data.errorMsg) {
                dialogModal.msg = response.data.errorMsg;
                dialogModal.msg2 = response.data.errorMsg2;
                dialogModal.show = true;

                competitorClassSection.checked_detailed = false;
                competitorClassSection.checked_replay = false;
                return;
            }

            if (response.data.features.length === 0) {
                competitorClassSection.noData = true;
                // console.log("response.data", response.data);
                competitorClassSection.noDataReason = response.data.not_available_reason;
                console.log("response.data.not_available_reason", response.data.not_available_reason);
                console.info("CCS not available (perhaps, section still running with rolling start or DNS");
                return;
            }

            if (myProps.timeSliderMin > response.data.min_ts) {
                myProps.timeSliderMin = response.data.min_ts;
                if (myProps.timeSliderValue === 0) {
                    myProps.timeSliderValue = parseInt(myProps.timeSliderMin);
                }

                if (myProps.timeSliderValue < myProps.timeSliderMin) {
                    myProps.timeSliderValue = parseInt(myProps.timeSliderMin);
                }
            }

            if (response.data.ccs_start_at_w_offset) {
                myProps.dss_ts = response.data.ccs_start_at_w_offset;
            } else {
                console.info("missing ccs_start_at_w_offset", competitorClassSection.id);
            }

            if (myProps.timeSliderMax < response.data.max_ts) {
                myProps.timeSliderMax = response.data.max_ts;
            }

            competitorClassSectionsPlayerData[competitorClassSection.id] = {
                geojson: response.data,
                geojson_penalties_features: [],
                class_section_id: section.id,
            };

            // Overwrite p_sec per tracepoint on init.
            // Take data from penalties, match to tracepoints
            if (competitorClassSection.penalties.length > 0) {
                // console.time("penalty init");
                for (
                    let i = 0,
                        k = Object.keys(
                            competitorClassSectionsPlayerData[competitorClassSection.id].geojson.features,
                        ),
                        l = k.length;
                    i < l;
                    i++
                ) {
                    const feature =
                        competitorClassSectionsPlayerData[competitorClassSection.id].geojson.features[k[i]];
                    if (feature.properties.p_sec > 0) {
                        // find penalty
                        for (let i = 0, l = competitorClassSection.penalties.length; i < l; i++) {
                            const penalty = competitorClassSection.penalties[i];
                            // console.log("penalty", penalty);
                            if (
                                feature.properties.id >= penalty.extra.first_tracepoint_id &&
                                feature.properties.id <= penalty.extra.last_tracepoint_id
                            ) {
                                competitorClassSectionsPlayerData[
                                    competitorClassSection.id
                                ].geojson_penalties_features.push(feature);
                                feature.properties["p_sec_formatted"] =
                                    "-" + Duration.fromMillis(penalty.seconds * 1000).toFormat("hh:mm:ss");
                                feature.properties["penalty_id"] = penalty.id;
                                if (feature.properties.id < penalty.extra.last_tracepoint_id) {
                                    break; // optimisation
                                }
                            }
                        }
                    }
                }

                // console.timeEnd("penalty init");
            }

            // lai min un max būtu updeitoti map componentē, vajag izmantot nextTick
            nextTick(() => {
                mapComponent.value.drawCcsOnMap({
                    type: type,
                    ccs_id: competitorClassSection.id,
                    ccs: competitorClassSection,
                    competitorIndex: competitorIndex,
                });
            });
        })
        .catch((err) => {
            competitorClassSection.checked_detailed = false;
            competitorClassSection.checked_replay = false;
        })
        .finally(() => {
            competitorClassSection.isLoadingCcsData = false;
        });
}

function loadCompetitorClassSectionTrackVersionData(section, competitorClassSection) {
    competitorClassSection.isLoadingrackVersionData = true;
    axios
        .get(
            route("player.load_competitor_class_section_track", {
                competitor_class_section_id: competitorClassSection.id,
                t: Math.round(new Date().getTime() / 1000),
            }),
        )
        .then((response) => {
            if (response.data.length === 0) {
                console.info("CCS not available (perhaps, section still running with rolling start");
                return;
            }
            trackVersionsData[section.id] = response.data;
            mapComponent.value.drawTrackVersionOnMap({
                class_section_id: section.id,
            });
        })
        .finally(() => {
            competitorClassSection.isLoadingrackVersionData = false;
        });
}

// kad atvr linku ar hash selected, tad initial load lādē arī daudz reizes vienu un to pašu track
// lai no tā izvairītos, te papildus array ar uz ielādi padotajiem section (tracks).
const alreadyLoadingSectionTracks = [];

provide("showCompetitorClassSection", showCompetitorClassSection);

function showCompetitorClassSection(section, ccs, competitorIndex, type, skipUrlUpdate = false) {
    // show or hide?
    if (ccs[`checked_${type}`]) {
        // show

        if (!skipUrlUpdate) {
            // last clicked CCS will be shown in the penalties sidebar
            myProps.penaltiesSidebarCcs = ccs.id;
        }

        // ccs
        if (competitorClassSectionsPlayerData[ccs.id]) {
            mapComponent.value.drawCcsOnMap({
                type: type,
                ccs_id: ccs.id,
                ccs: ccs,
                competitorIndex: competitorIndex,
            });
        } else {
            loadCompetitorClassSectionData(ccs, competitorIndex, type, section);
        }

        // track version
        if (trackVersionsData[section.id]) {
            mapComponent.value.drawTrackVersionOnMap({
                class_section_id: section.id,
            });
        } else {
            if (!alreadyLoadingSectionTracks.includes(section.id)) {
                loadCompetitorClassSectionTrackVersionData(section, ccs);
                alreadyLoadingSectionTracks.push(section.id);
            }
        }
    } else {
        // hide
        mapComponent.value.hideCcsFromMap({
            type: type,
            ccs: ccs,
        });

        // noskaidrojam vai šajā sekcijā vairs nav redzamu ccs
        // ja nav, tad paslēpjam track
        let shouldHide = true;
        for (let i = 0, l = section.competitorClassSections.length; i < l; i++) {
            if (
                section.competitorClassSections[i].checked_detailed ||
                section.competitorClassSections[i].checked_replay
            ) {
                shouldHide = false;
            }
        }

        if (shouldHide === true) {
            mapComponent.value.hideTrackVersionFromMap({
                class_section_id: section.id,
            });
        }
    }

    if (!skipUrlUpdate) {
        updateLocationHash();
    }
}

provide("updateLocationHash", updateLocationHash);

function updateLocationHash() {
    const checkedReplay = [];
    const checkedDetailed = [];
    if (props.event) {
        for (let i3 = 0, l3 = props.event.classes.length; i3 < l3; i3++) {
            for (let i2 = 0, l2 = props.event.classes[i3].classSections.length; i2 < l2; i2++) {
                const sect = props.event.classes[i3].classSections[i2];

                for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                    if (sect.competitorClassSections[i].checked_replay) {
                        checkedReplay.push(sect.competitorClassSections[i].id);
                    }
                    if (sect.competitorClassSections[i].checked_detailed) {
                        checkedDetailed.push(sect.competitorClassSections[i].id);
                    }
                }
            }
        }
    }

    if (props.track) {
        for (let i2 = 0, l2 = props.track.classSectionsAllIndividuals.length; i2 < l2; i2++) {
            const sect = props.track.classSectionsAllIndividuals[i2];

            for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                if (sect.competitorClassSections[i].checked_replay) {
                    checkedReplay.push(sect.competitorClassSections[i].id);
                }
                if (sect.competitorClassSections[i].checked_detailed) {
                    checkedDetailed.push(sect.competitorClassSections[i].id);
                }
            }
        }
    }

    /*
//  using query string in place of hash
if (!skipUrlUpdate) {
if (inIframe()) {
    const url = new URL(window.top.location);
    url.searchParams.set("ccs_r", checkedReplay.join(","));
    url.searchParams.set("ccs_d", checkedDetailed.join(","));
    // window.history.pushState({ nonInertiaVisit: true, key: Date.now() + "" }, null, url);
    window.top.history.replaceState({}, "", url);
} else {
    const url = new URL(window.location);
    url.searchParams.set("ccs_r", checkedReplay.join(","));
    url.searchParams.set("ccs_d", checkedDetailed.join(","));
    // window.history.pushState({ nonInertiaVisit: true, key: Date.now() + "" }, null, url);
    window.history.replaceState({}, "", url);
}
}*/

    if (isSameOrigin()) {
        if (inIframe()) {
            window.top.location.hash = `#ccs=${checkedReplay.join(",")}|${checkedDetailed.join(",")}`;
        }
        window.location.hash = `#ccs=${checkedReplay.join(",")}|${checkedDetailed.join(",")}`;
    }
}

function onMapInit() {
    myProps.isMapInited = true;

    const hash = window.location.hash;
    // console.log("hash", hash);
    if (hash.startsWith("#ccs=")) {
        if (window.screen.width <= 1020) {
            // uz maza ekrāna nerādam sānu paneļus, ja nāk ar kko selektētu iekš URL,
            // lai pirmreizējie apmekļetāji neapjūk
            // it sevišķi no landingpage kad nāk ievērtēt

            myProps.isPenaltiesSidebarOpen = false;
            staticDesktopSidebarOpen.value = false;
        }

        // console.log('hash.split("=")', hash.split("="));
        const tmp = decodeURI(hash).split("=")[1].split("|");
        let checkedReplay = tmp[0].split(",");
        let checkedDetailed = [];
        if (tmp[1]) {
            checkedDetailed = tmp[1].split(",");
        }

        checkedReplay = checkedReplay.map((item) => parseInt(item));
        checkedDetailed = checkedDetailed.map((item) => parseInt(item));
        // console.log("checkedReplay", checkedReplay);
        // console.log("checkedDetailed", checkedDetailed);

        if (props.event) {
            for (let i3 = 0, l3 = props.event.classes.length; i3 < l3; i3++) {
                for (let i2 = 0, l2 = props.event.classes[i3].classSections.length; i2 < l2; i2++) {
                    const sect = props.event.classes[i3].classSections[i2];
                    let isAllInSectionChecked = true;

                    for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                        if (checkedReplay.includes(sect.competitorClassSections[i].id)) {
                            sect.competitorClassSections[i].checked_replay = true;
                            props.event.classes[i3].isOpen = true;
                            sect.isOpen = true;
                            showCompetitorClassSection(
                                sect,
                                sect.competitorClassSections[i],
                                i,
                                "replay",
                                true,
                            );
                        } else {
                            isAllInSectionChecked = false;
                        }
                        if (checkedDetailed.includes(sect.competitorClassSections[i].id)) {
                            sect.competitorClassSections[i].checked_detailed = true;
                            props.event.classes[i3].isOpen = true;
                            sect.isOpen = true;
                            // ja detailed ieklikšķināts bijis padots caur URL, tad tam atveram penalties
                            myProps.penaltiesSidebarCcs = sect.competitorClassSections[i].id;
                            showCompetitorClassSection(
                                sect,
                                sect.competitorClassSections[i],
                                i,
                                "detailed",
                                true,
                            );
                        }
                    }

                    if (isAllInSectionChecked) {
                        sect.isAllChecked = true;
                    }
                }
            }
        } else {
            for (let i2 = 0, l2 = props.track.classSectionsAllIndividuals.length; i2 < l2; i2++) {
                const sect = props.track.classSectionsAllIndividuals[i2];
                let isAllInSectionChecked = true;

                for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                    if (checkedReplay.includes(sect.competitorClassSections[i].id)) {
                        sect.competitorClassSections[i].checked_replay = true;
                        props.track.classSectionsAllIndividuals[i2].isOpen = true;
                        sect.isOpen = true;
                        showCompetitorClassSection(sect, sect.competitorClassSections[i], i, "replay", true);
                    } else {
                        isAllInSectionChecked = false;
                    }
                    if (checkedDetailed.includes(sect.competitorClassSections[i].id)) {
                        sect.competitorClassSections[i].checked_detailed = true;
                        props.track.classSectionsAllIndividuals[i2].isOpen = true;
                        sect.isOpen = true;
                        // ja detailed ieklikšķināts bijis padots caur URL, tad tam atveram penalties
                        myProps.penaltiesSidebarCcs = sect.competitorClassSections[i].id;
                        showCompetitorClassSection(sect, sect.competitorClassSections[i], i, "detailed", true);
                    }
                }

                if (isAllInSectionChecked) {
                    sect.isAllChecked = true;
                }
            }
        }
    }
}

// onMapInit using query string
/*function onMapInit() {
    const params = new URLSearchParams(document.location.search);
    let checkedReplay = params.get("ccs_r");
    let checkedDetailed = params.get("ccs_d");
    if (checkedReplay || checkedDetailed) {
        if (checkedReplay) {
            checkedReplay = checkedReplay.split(",");
            checkedReplay = checkedReplay.map((item) => parseInt(item));
        }
        if (checkedDetailed) {
            checkedDetailed = checkedDetailed.split(",");
            checkedDetailed = checkedDetailed.map((item) => parseInt(item));
        }

        console.log("checkedReplay", checkedReplay);
        console.log("checkedDetailed", checkedDetailed);

        for (let i3 = 0, l3 = props.event.classes.length; i3 < l3; i3++) {
            props.event.classes[i3].isOpen = false;
            for (let i2 = 0, l2 = props.event.classes[i3].classSections.length; i2 < l2; i2++) {
                const sect = props.event.classes[i3].classSections[i2];
                sect.isOpen = false;

                let isAllInSectionChecked = true;

                for (let i = 0, l = sect.competitorClassSections.length; i < l; i++) {
                    sect.competitorClassSections[i].checked_replay = false;
                    sect.competitorClassSections[i].checked_detailed = false;

                    if (checkedReplay && checkedReplay.includes(sect.competitorClassSections[i].id)) {
                        sect.competitorClassSections[i].checked_replay = true;
                        props.event.classes[i3].isOpen = true;
                        sect.isOpen = true;
                        showCompetitorClassSection(sect, sect.competitorClassSections[i], i, "replay");
                    } else {
                        isAllInSectionChecked = false;
                    }
                    if (checkedDetailed && checkedDetailed.includes(sect.competitorClassSections[i].id)) {
                        sect.competitorClassSections[i].checked_detailed = true;
                        props.event.classes[i3].isOpen = true;
                        sect.isOpen = true;
                        showCompetitorClassSection(sect, sect.competitorClassSections[i], i, "detailed");
                    }
                }

                if (isAllInSectionChecked) {
                    sect.isAllChecked = true;
                }
            }
        }
    }
}*/

const isAnySectionsLoading = computed(() => {
    if (props.event) {
        for (let i = 0, l = props.event.classes.length; i < l; i++) {
            for (let i2 = 0, l2 = props.event.classes[i].classSections.length; i2 < l2; i2++) {
                for (
                    let i3 = 0, l3 = props.event.classes[i].classSections[i2].competitorClassSections.length;
                    i3 < l3;
                    i3++
                ) {
                    if (
                        props.event.classes[i].classSections[i2].competitorClassSections[i3].isLoadingCcsData ||
                        props.event.classes[i].classSections[i2].competitorClassSections[i3]
                            .isLoadingrackVersionData
                    ) {
                        return true;
                    }
                }
            }
        }
    } else {
        console.log("TRACK isAnySectionsLoading");
    }

    return false;
});

let pageWidth = 1920;
// do not run in SSR
if (typeof window !== "undefined") {
    pageWidth = window.innerWidth || document.body.clientWidth;
}
const treshold = Math.max(1, Math.floor(0.01 * pageWidth));
let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;

const limit = Math.tan(((45 * 1.5) / 180) * Math.PI);

function handleTouchMoveLeftMenu(e) {
    const x = touchendX - touchstartX;
    const y = touchendY - touchstartY;
    const xy = Math.abs(x / y);
    const yx = Math.abs(y / x);
    if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
        if (yx <= limit) {
            if (x < 0) {
                // console.log("left");
                staticDesktopSidebarOpen.value = false;
            } else {
                // console.log("right");
            }
        }
        if (xy <= limit) {
            if (y < 0) {
                // console.log("top");
            } else {
                // console.log("bottom");
            }
        }
    } else {
        // console.log("tap");
    }
}

function handleTouchMovePenaltiesSidebar(e) {
    const x = touchendX - touchstartX;
    const y = touchendY - touchstartY;
    const xy = Math.abs(x / y);
    const yx = Math.abs(y / x);
    if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
        if (yx <= limit) {
            if (x < 0) {
                //   console.log("left");
            } else {
                // right
                myProps.isPenaltiesSidebarOpen = false;
            }
        }
        if (xy <= limit) {
            if (y < 0) {
                // console.log("up");
            } else {
                // console.log("down");
            }
        }
    } else {
        // tap
        //   console.log("tap");
    }
}

const ccsColors = [
    "#FF5733",
    "#FFC300",
    "#DAF7A6",
    "#FF9A00",
    "#C70039",
    "#900C3F",
    "#581845",
    "#1E8449",
    "#2ECC71",
    "#16A085",
    "#48C9B0",
    "#A3E4D7",
    "#3498DB",
    "#5DADE2",
    "#2874A6",
    "#8E44AD",
    "#D2B4DE",
    "#F39C12",
    "#F5B041",
    "#DC7633",
    "#D35400",
    "#6C3483",
    "#B3B6B7",
    "#E74C3C",
    "#EC7063",
    "#CB4335",
    "#922B21",
    "#1ABC9C",
    "#73C6B6",
    "#117A65",
    "#2E4053",
    "#566573",
    "#1B4F72",
    "#641E16",
    "#78281F",
    "#512E5F",
    "#A569BD",
    "#C39BD3",
    "#D68910",
    "#AF7AC5",
    "#F4D03F",
    "#F8C471",
    "#F1948A",
    "#D7DBDD",
    "#ABB2B9",
    "#FAD7A0",
    "#E59866",
    "#F7DC6F",
    "#CCD1D1",
    "#85929E",
];

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function isSameOrigin() {
    try {
        const isSameOrigin = window.top.location.origin === window.location.origin;
        // console.log("isSameOrigin", isSameOrigin);
        return isSameOrigin;
    } catch (e) {
        return false;
    }
}

const hashchangeListener = function (e) {
    if (inIframe()) {
        try {
            const doc = window.top.document.documentElement;
            // const left = (window.top.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            const top = (window.top.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            // console.log("top", top);
            window.top.scrollTo(0, top);
        } catch (e) {
            // console.log("dddddddd");
        }
    }
};

onMounted(() => {
    // console.log("onMounted");

    // console.log("inIframe", inIframe());
    // console.log("isSameOrigin", isSameOrigin());
    if (inIframe()) {
        // stop scroll to top if hash changed
        // saliekas vairāki listeneri, tāpēc hashchangeListener ir try cacth
        if (isSameOrigin()) {
            window.top.addEventListener("hashchange", hashchangeListener, false);
        }
        // console.log("add hashchange");
    }

    const gestureZone = document.getElementById("replay-menu-swiper");

    gestureZone.addEventListener(
        "touchstart",
        function (event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        },
        false,
    );

    gestureZone.addEventListener(
        "touchend",
        function (event) {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleTouchMoveLeftMenu(event);
        },
        false,
    );

    const gestureZone2 = document.getElementById("penalties-sidebar-swiper");

    gestureZone2.addEventListener(
        "touchstart",
        function (event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        },
        false,
    );

    gestureZone2.addEventListener(
        "touchend",
        function (event) {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleTouchMovePenaltiesSidebar(event);
        },
        false,
    );
});

onUnmounted(() => {});
</script>

<template>
    <Toast />
    <Head>
        <title>Replay: {{ $page.props.event ? $page.props.event.name : $page.props.track.name }}</title>

        <meta
            v-if="event"
            property="og:title"
            head-key="og:title"
            :content="`Event replay: ${$page.props.meta_event_name}`"
        />

        <meta
            v-if="track"
            property="og:title"
            head-key="og:title"
            :content="`Track replay: ${$page.props.meta_track_name}`"
        />
    </Head>

    <!-- Static sidebar for desktop -->
    <transition
        v-show="staticDesktopSidebarOpen"
        enter-active-class="transition ease-in-out duration-300 transform"
        enter-from-class="-translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transition ease-in-out duration-300 transform"
        leave-from-class="translate-x-0"
        leave-to-class="-translate-x-full"
        appear
    >
        <div
            class="content-full-screen-height-mb-24 fixed inset-y-0 z-30 flex w-80 flex-col bg-opacity-40 sm:w-96"
        >
            <div
                class="scrollbar-hide flex grow flex-col gap-y-5 overflow-y-scroll bg-slate-900 bg-opacity-30 pb-4"
            >
                <nav
                    id="replay-menu-swiper"
                    class="flex flex-1 flex-col"
                >
                    <div class="relative z-10 mb-2">
                        <HeadingComponent class="w-80 bg-white bg-opacity-80 p-4 shadow-xl sm:w-96">
                            <template #name>
                                <template v-if="event">Event</template>
                                <template v-if="track">Track</template>
                                Replay
                                <SpinnerIcon
                                    v-show="isAnySectionsLoading"
                                    class="inline size-6"
                                ></SpinnerIcon>
                            </template>
                            <template #description>
                                <a
                                    v-if="event"
                                    target="_top"
                                    :href="
                                        route('event.public.information', {
                                            hashid: event.hashid,
                                            seo_slug: event.seo_slug,
                                        })
                                    "
                                    >{{ event.name }}</a
                                >
                                <a
                                    v-if="track"
                                    target="_top"
                                    :href="
                                        route('track.public.information', {
                                            pin: track.pin,
                                            seo_slug: track.seo_slug,
                                        })
                                    "
                                    >{{ track.name }}</a
                                >
                            </template>
                        </HeadingComponent>
                    </div>
                    <SpinnerIcon
                        v-show="myProps.isMapInited === false"
                        class="m-6 size-16 self-center"
                    ></SpinnerIcon>
                    <PlayerSectionsMenuEvent
                        v-if="event && myProps.isMapInited"
                        :event="event"
                        :track-versions-data="trackVersionsData"
                        :map-component="mapComponent"
                        :player-props="myProps"
                    ></PlayerSectionsMenuEvent>
                    <PlayerSectionsMenuTrack
                        v-if="track && myProps.isMapInited"
                        :track="track"
                        :track-versions-data="trackVersionsData"
                        :map-component="mapComponent"
                        :player-props="myProps"
                    ></PlayerSectionsMenuTrack>
                    <PlayerLogoBlock v-if="inIframe() && !isSameOrigin()" />
                </nav>
            </div>
        </div>
    </transition>

    <transition
        v-show="myProps.isPenaltiesSidebarOpen"
        enter-active-class="transition ease-in-out duration-200 transform"
        enter-from-class="translate-x-full"
        enter-to-class="-translate-x-0"
        leave-active-class="transition ease-in-out duration-200 transform"
        leave-from-class="-translate-x-0"
        leave-to-class="translate-x-full"
        appear
    >
        <div
            v-show="myProps.isPenaltiesSidebarOpen && myProps.ridesPositionFeature"
            id="penalties-sidebar-swiper"
            class="content-full-screen-height-mb-24 fixed inset-y-0 right-0 z-20 flex w-56 flex-col"
        >
            <div
                v-if="myProps.ridesPositionFeature"
                class="scrollbar-hide flex grow flex-col gap-y-5 overflow-y-scroll bg-slate-900 bg-opacity-70 p-4"
            >
                <ccs-penalties-tooltip-content
                    :ccs="myProps.ridesPositionFeature.ccs"
                    :player-props="myProps"
                    :track-versions-data="trackVersionsData"
                    :penalty_types="$page.props.penalty_types"
                    :competitor_states="$page.props.competitor_states"
                    :group-penalties="false"
                    :show-edit-penalties-link="true"
                    :map-component="mapComponent"
                ></ccs-penalties-tooltip-content>
            </div>
        </div>
    </transition>

    <div>
        <div
            :class="staticDesktopSidebarOpen ? 'hidden' : ''"
            class="absolute left-3 top-3 z-20 flex shrink-0 cursor-pointer items-center rounded-full bg-white bg-opacity-80 px-6 py-4 shadow-sm"
            @click="staticDesktopSidebarOpen = !staticDesktopSidebarOpen"
        >
            <span class="sr-only">Open sidebar</span>
            <ListBulletIcon
                class="size-6"
                aria-hidden="true"
            />
        </div>

        <div
            :class="!staticDesktopSidebarOpen ? 'hidden' : ''"
            class="absolute left-60 top-3 z-40 ml-2 flex shrink-0 cursor-pointer sm:left-96 sm:ml-3"
        >
            <button
                type="button"
                class="rounded-xl bg-gray-400 p-2.5"
                @click="staticDesktopSidebarOpen = false"
            >
                <span class="sr-only">Close sidebar</span>
                <ChevronLeftIcon
                    class="size-6 text-white"
                    aria-hidden="true"
                />
            </button>
        </div>

        <main>
            <PlayerMap
                ref="mapComponent"
                :player-props="myProps"
                :competitor-class-sections-player-data="competitorClassSectionsPlayerData"
                :track-versions-data="trackVersionsData"
                :ccs-colors="ccsColors"
                class="content-full-screen-height-mb-24 flex-1"
                @on-map-init="
                    (val) => {
                        onMapInit();
                    }
                "
                @tracepoint-clicked="
                    (feature) => {
                        modalDeleteTracepoints.show = true;
                        modalDeleteTracepoints.feature = feature;
                    }
                "
            />

            <DialogModal
                :show="modalDeleteTracepoints.show"
                max-width="xl"
                :closeable="true"
                @close="
                    () => {
                        modalDeleteTracepoints.show = false;
                    }
                "
            >
                <template #title> Delete trace point</template>
                <template #content>
                    <div class="space-y-6">
                        <pre>ID: {{ modalDeleteTracepoints.feature.properties.id }}</pre>
                        <pre>ts_ms: {{ modalDeleteTracepoints.feature.properties.ts_ms }}</pre>

                        <div
                            class="mb-4 rounded-lg bg-red-50 p-4 text-sm text-red-800"
                            role="alert"
                        >
                            <span class="font-medium">Warning!</span> This operation is irreversible!
                        </div>
                        <p class="text-sm">*competitor results will be recalculated after deletion</p>
                        <div class="text-red-500"></div>
                        <hr />
                        <Button
                            color="red"
                            @click="confirmTracepointDeletion('clicked')"
                            >Delete clicked trace point
                        </Button>
                        <hr />
                        <div>
                            <Button
                                color="red"
                                @click="confirmTracepointDeletion('after')"
                                >Delete all trace points <strong>&nbsp;after&nbsp;</strong> clicked trace point
                            </Button>
                            <br />
                            <span class="text-sm">*ending part of the trace</span>
                        </div>
                        <hr />
                        <div>
                            <Button
                                color="red"
                                @click="confirmTracepointDeletion('before')"
                                >Delete all trace points <strong>&nbsp;before&nbsp;</strong> clicked trace point
                            </Button>
                            <br />
                            <span class="text-sm">*beginning part of the trace</span>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <Button
                        variant="outline"
                        @click="modalDeleteTracepoints.show = false"
                    >
                        Cancel
                    </Button>
                </template>
            </DialogModal>

            <PlayerPenaltiesControl
                :player-props="myProps"
                :track-versions-data="trackVersionsData"
                @on-toggle-penalties-sidebar="
                    () => {
                        myProps.isPenaltiesSidebarOpen = !myProps.isPenaltiesSidebarOpen;
                    }
                "
            ></PlayerPenaltiesControl>

            <PlayerSlider
                :player-props="myProps"
                @on-click-dss="
                    () => {
                        mapComponent.tryToDrawRiderOnNextTracepoint();
                    }
                "
            ></PlayerSlider>
        </main>

        <CompetitorClassSectionPenaltiesFormModal
            v-if="$page.props.can.view_sensitive_event || $page.props.can.view_sensitive_track"
            :player-props="myProps"
            :track-versions-data="trackVersionsData"
            :event="$page.props.event"
            :track="$page.props.track"
            @update:ccs-from-server="
                (ccsFromServer) => {
                    updateCcsFromPenaltiesModal(ccsFromServer);
                }
            "
        ></CompetitorClassSectionPenaltiesFormModal>

        <dialog-modal
            :show="dialogModal.show"
            @close="dialogModal.show = false"
        >
            <template #title>You do not have access to the roadbook track replay</template>

            <template #content>
                <div class="mt-4 space-y-3">
                    <p class="text-red-500">{{ dialogModal.msg }}<br /></p>
                    <p>
                        {{ dialogModal.msg2 }}
                    </p>
                </div>
                <div
                    v-if="props.track && props.track.pin"
                    class="mt-4 space-y-3"
                >
                    <strong>If you have already driven this track</strong>, please
                    <a
                        target="_top"
                        :href="`/after-auth-intended-track-route/${props.track.pin}`"
                        >Log in</a
                    >
                    to view the rides and their replays.
                </div>
            </template>

            <template #footer>
                <Button
                    color="white"
                    @click="dialogModal.show = false"
                >
                    Close
                </Button>
            </template>
        </dialog-modal>
    </div>
</template>
